/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_PlaybrainInputs */

const ja_common_playbrain = /** @type {(inputs: Common_PlaybrainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PLAYBRAIN`)
};

const en_common_playbrain = /** @type {(inputs: Common_PlaybrainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PLAYBRAIN`)
};

/**
* | output |
* | --- |
* | "PLAYBRAIN" |
*
* @param {Common_PlaybrainInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const common_playbrain = /** @type {((inputs?: Common_PlaybrainInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_PlaybrainInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_common_playbrain(inputs)
	return en_common_playbrain(inputs)
});